import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-xl-10 mb-5" }
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-4" }
const _hoisted_5 = { class: "col bg-light-success px-3 py-4 rounded-2 my-2 text-center d-flex flex-column justify-content-center align-items-center h-150px" }
const _hoisted_6 = { class: "svg-icon svg-icon-3x svg-icon-success d-block my-2" }
const _hoisted_7 = { class: "text-success h2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-success fw-bold fs-6" }, "Proposer", -1)
const _hoisted_9 = { class: "col-6 col-md-4" }
const _hoisted_10 = { class: "col bg-light-primary px-3 py-4 rounded-2 my-2 text-center d-flex flex-column justify-content-center align-items-center h-150px" }
const _hoisted_11 = { class: "svg-icon svg-icon-2x svg-icon-primary d-block my-2" }
const _hoisted_12 = { class: "text-primary h2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary fw-bold fs-6" }, "Proposal name", -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-4\"><div class=\"col bg-light-info px-3 py-4 rounded-2 my-2 text-center d-flex flex-column justify-content-center align-items-center h-150px\"><i class=\"bi bi-currency-exchange fa-2x text-info my-2\"></i><span class=\"text-info h2\">0/0</span><span class=\"text-info fw-bold fs-6\">Approval status</span></div></div>", 1)
const _hoisted_15 = {
  key: 1,
  class: "card-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/abstract/abs026.svg" })
                ]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.proposer), 1),
                _hoisted_8
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil001.svg" })
                ]),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.proposalName), 1),
                _hoisted_13
              ])
            ]),
            _hoisted_14
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_Loading, { height: '150px' })
        ]))
  ]))
}